(function () {
  var KEY = 'z23_lang';
  var root = document.documentElement;

  function save(lang) {
    try { localStorage.setItem(KEY, lang); } catch (e) {}
  }

  function current() {
    return root.getAttribute('data-z23-lang') === 'en' ? 'en' : 'ja';
  }

  function sync() {
    var lang = current();
    var btns = document.querySelectorAll('[data-z23-lang-set]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].setAttribute('aria-pressed', btns[i].getAttribute('data-z23-lang-set') === lang ? 'true' : 'false');
    }
  }

  function apply(lang) {
    root.setAttribute('data-z23-lang', lang);
    root.lang = lang;
    save(lang);
    sync();
    if (window.ScrollTrigger && typeof window.ScrollTrigger.refresh === 'function') {
      window.ScrollTrigger.refresh();
    }
    window.dispatchEvent(new Event('resize'));
  }

  function bind() {
    var btns = document.querySelectorAll('[data-z23-lang-set]');
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].dataset.z23LangBound) continue;
      btns[i].dataset.z23LangBound = '1';
      btns[i].addEventListener('click', function () {
        apply(this.getAttribute('data-z23-lang-set') === 'en' ? 'en' : 'ja');
      });
    }
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  document.addEventListener('shopify:section:load', bind);
})();
